/**
 * Router definition for the Cash Refunds module.
 *
 * /cash-refunds       → redirects to /cash-refunds/list
 * /cash-refunds/list  → CashRefundList (the ops queue)
 */

import {
  LoaderFunctionArgs,
  Outlet,
  redirect,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { useEffect } from "react";
import { Breadcrumb } from "../../components/Breadcrumb";
import { CashRefundList, cashRefundsLoader } from "./CashRefundList";
import { requireAuth } from "../auth/RequireAuth";
import { userStore } from "../../store/user";
import { cashRefundAccessFor } from "./access";

const CashRefundIndex = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.pathname === "/cash-refunds") {
      navigate("/cash-refunds/list", { replace: true });
    }
  }, [location.pathname, navigate]);

  return <Outlet />;
};

// The nav link is not a control — /cash-refunds/list is guessable — so the
// route re-checks on entry. Mirrors stripe_connect.
const guardLoader = (loader?: (args: LoaderFunctionArgs) => unknown) =>
  requireAuth(undefined, async (args: LoaderFunctionArgs) => {
    if (!cashRefundAccessFor(userStore.getState().user).access) {
      return redirect("/");
    }
    return loader ? await loader(args) : null;
  });

export const cashRefundsRouter = {
  path: "/cash-refunds",
  id: "cash-refunds",
  element: <CashRefundIndex />,
  loader: guardLoader(),
  handle: {
    crumb: () => <Breadcrumb name="Cash Refunds" href="/cash-refunds/list" />,
  },
  children: [
    {
      path: "list",
      id: "cash-refunds-list",
      element: <CashRefundList />,
      loader: guardLoader(cashRefundsLoader),
    },
  ],
};
